import { ConfigurableCard } from "../components/ConfigurableCard";
import { useTemplateContext } from "../provider";
import { ApplicantType } from "shared/types";
import { buildVerificationSchemaData, getValueByPath } from "../utils";
import { SwitchWithReadOnlyMode } from "../SwitchWithReadOnlyMode";

export const IdentityVerificationSlice = () => {
  const { readOnly, template, partnerType, setTemplate } = useTemplateContext();

  const identityVerificationPath = [
    "settings",
    partnerType,
    "identity_verification"
  ];

  const toggleVerification = (keys: string[], value: boolean) => {
    if (!template) return;
    const updatedTemplate = buildVerificationSchemaData(template, keys, value);

    setTemplate(updatedTemplate);
  };

  if (!template) return null;

  const selfieCheck =
    template.settings[partnerType].identity_verification?.selfie_check;

  const customer =
    partnerType === ApplicantType.Applicant ? "applicants" : "guarantors";

  return (
    <ConfigurableCard title="General settings">
      <SwitchWithReadOnlyMode
        readOnly={readOnly}
        disabled={readOnly}
        onChange={(v) =>
          toggleVerification([...identityVerificationPath, "selfie_check"], v)
        }
        checked={Boolean(
          getValueByPath(template, [
            ...identityVerificationPath,
            "selfie_check"
          ])
        )}
        label={
          <div className="space-y-1">
            <p className="text-sm font-medium text-content-700">
              {readOnly
                ? `${selfieCheck ? "Ask" : "Don't ask"} ${customer} to complete selfie check`
                : `Ask ${customer} to complete selfie check`}
            </p>
            <p className="text-sm text-content-300">
              Selfie check confirms the live video matches the document photo
            </p>
          </div>
        }
      />

      <SwitchWithReadOnlyMode
        readOnly={readOnly}
        disabled={readOnly}
        onChange={(v) =>
          toggleVerification(
            [...identityVerificationPath, "prevent_apply_if_failed"],
            v
          )
        }
        checked={getValueByPath(template, [
          ...identityVerificationPath,
          "prevent_apply_if_failed"
        ])}
        label="Prevent applicants with failed identity verification from submitting an application"
      />
    </ConfigurableCard>
  );
};
